module.exports = __webpack_public_path__ + "img/whiteTick-icon.e1fafe43.svg";